/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import Select from '@tds/core-select';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Button from '@tds/core-button';
import ButtonGroup from '@tds/core-button-group';
import { InputWrapper, DateWrapper, ButtonWrapper } from './css';
import { Box, Text } from '../design/css';
import TypeAhead from '../orderDetails/typeAhead';
import MultiSelect from './multiselect';
import 'react-datepicker/dist/react-datepicker.css';

const Filters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  fieldsToHide,
  isWlsFilter
}) => {
  const {
    startDate,
    endDate,
    filterCriteria,
    assignee,
    channelId,
    province,
    createdBy,
    status,
    dealership,
    reasonForSubmission,
    orderNotEligibleforMssReason,
    flag,
    reasonForOrderReturned
  } = filterState;
  const {
    completedAt,
    createdAt,
    orderAssignedTo,
    filterByChannel,
    filterByProvince,
    channelName,
    filterByAssignee,
    filterByDates,
    filterBySalesRep,
    filterByStatus,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    filterByDealership,
    filtersDropdownTitle,
    statusLabel,
    wlsFiltersStatusOptions,
    labelFilterByReasonForSubmission,
    labelFilterByOrderNotEligibleForMSSReason,
    labelFilterByFlags,
    labelFilterByResonReturningOrder
  } = staticLabels;
  const { salesRepNames, channels, assignees, dealerships, reasonForSubmissions = [], orderNotEligibleForMSSReasons = [], flags = [], reasonsForOrderReturned = [] } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  const dealershipsList =
    dealerships &&
    dealerships.map(dealership => ({
      label: dealership.name,
      value: dealership.id
    }));
  const reasonForSubmissionList =   reasonForSubmissions && reasonForSubmissions.map(reason => ({ label: reason.text, value: reason.value }));
  const orderNotEligibleforMssReasonList = orderNotEligibleForMSSReasons && orderNotEligibleForMSSReasons.map(reason => ({ label: reason.text, value: reason.value }));
  const flagList = flags && flags.map(flag => ({ label: flag.text, value: flag.value }));
  const reasonsForOrderReturnedList = reasonsForOrderReturned && reasonsForOrderReturned.map(reason => ({ label: reason.text, value: reason.value }));
  const getButtonGroup = () => (
    <ButtonWrapper>
      <ButtonGroup
        name="filterDates"
        label=" "
        onChange={({ target: { value } }) =>
          updateFilters('filterCriteria', value)
        }
        value={filterCriteria}
      >
        <ButtonGroup.Item value="createdAt">{createdAt}</ButtonGroup.Item>
        <ButtonGroup.Item value="validatedAt">{completedAt}</ButtonGroup.Item>
      </ButtonGroup>
    </ButtonWrapper>
  );
  const multiSelectFilters = [
    {
      label: filterByProvince,
      name: 'province',
      options: [
        { label: 'Alberta', value: 'alberta' },
        { label: 'British Columbia', value: 'british_columbia' },
        { label: 'Manitoba', value: 'manitoba' },
        { label: 'New Brunswick', value: 'newBrunswick' },
        {
          label: 'Newfoundland and Labrador',
          value: 'newfoundlandAndLabrador'
        },
        { label: 'Northwest Territories', value: 'northwestTerritories' },
        { label: 'Nova Scotia', value: 'novaScotia' },
        { label: 'Nunavut', value: 'nunavut' },
        { label: 'Ontario', value: 'ontario' },
        { label: 'Prince Edward Island', value: 'princeEdwardIsland' },
        { label: 'Quebec', value: 'quebec' },
        { label: 'Saskatchewan', value: 'saskatchewan' },
        { label: 'Yukon', value: 'yukon' }
      ],
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterBySalesRep,
      name: 'createdBy',
      options: (salesRepNames || []).map(op => ({
        value: op.id,
        label: `${op.firstName} ${op.lastName}`
      })),
      value: createdBy
    },
    {
      label: filterByStatus,
      name: 'status',
      options: wlsFiltersStatusOptions,
      value: status
    },
    {
      label: filterByDealership,
      name: 'dealership',
      options: dealershipsList,
      value: dealership
    },
    {
      label: labelFilterByReasonForSubmission,
      name: 'reasonForSubmission',
      options: reasonForSubmissionList,
      value: reasonForSubmission,
      multiSelect : false
    },
    {
      label: labelFilterByOrderNotEligibleForMSSReason,
      name: 'orderNotEligibleforMssReason',
      options: orderNotEligibleforMssReasonList,
      value: orderNotEligibleforMssReason
    },
    {
      label: labelFilterByFlags,
      name: 'flag',
      options: flagList,
      value: flag,
      multiSelect: false
    },
    {
      label: labelFilterByResonReturningOrder,
      name: 'reasonForOrderReturned',
      options: reasonsForOrderReturnedList,
      value: reasonForOrderReturned
    }
  ];
  const selectFilters = [
    {
      label: filterByChannel,
      placeholder: channelName,
      options: channels,
      value: channelId,
      onChange: ({ target: { value } }) => updateFilters('channelId', value)
    }
  ];
  const typeAheadFilters = useMemo(
    () =>
      [
        {
          label: filterByAssignee,
          placeholder: orderAssignedTo,
          options: assignees,
          selected: assignee,
          onChange: value => updateFilters('assignee', value)
        }
      ].filter(
        i => (isWlsFilter && i.label !== filterByAssignee) || !isWlsFilter
      ),
    [assignees, channels, salesRepNames, filterState]
  );

  const getMultiSelectFilters = listOfFilters => {
    return listOfFilters.map(({ label, options, name, value, multiSelect = true }) => {
      if (fieldsToHide.includes(name)) {
        return <></>;
      }
      return (
        <div className="col-md-4">
          <MultiSelect
            updateFilters={updateFilters}
            label={label}
            options={options}
            name={name}
            value={value}
            isMulti = {multiSelect}
          />
        </div>
      );
    });
  };

  const getSelectFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, value, onChange, defaultValue }) => {
        return (
          options && (
            <div className="col-md-4">
              <Select
                label={label}
                placeholder={placeholder}
                options={options}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
              />
            </div>
          )
        );
      }
    );
  };
  const getTypeAheadFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, selected, onChange }) => {
        return (
          <div className="col-md-4">
            <TypeAhead
              label={label}
              placeholder={placeholder}
              options={options || []}
              selected={selected}
              onChange={onChange}
            />
          </div>
        );
      }
    );
  };

  const getDateFilters = () => {
    return (
      <div className="col-md-4">
        <Box
          style={{ paddingBottom: 6, paddingLeft: 0, marginTop: 10 }}
          className="col-md-12"
        >
          <Text>{filterByDates} </Text>
        </Box>
        {/* {!isWlsFilter && <Box>{getButtonGroup()}</Box>} */}
        <InputWrapper>
          <DateWrapper
            style={{
              marginRight: '15px',
              paddingLeft: 0
            }}
            className="col-md-6"
          >
            <DatePicker
              wrapperClassName="wlsDatePicker"
              dateFormat="yyyy/MM/dd"
              placeholderText={startDateLabel}
              selected={startDate}
              onChange={value => updateFilters('startDate', value)}
            />
          </DateWrapper>
          <DateWrapper
            style={{ marginRight: '5px', paddingLeft: 0 }}
            className="col-md-6"
          >
            <DatePicker
              wrapperClassName="wlsDatePicker"
              dateFormat="yyyy/MM/dd"
              placeholderText={endDateLabel}
              minDate={startDate}
              selected={endDate}
              onChange={value => updateFilters('endDate', value)}
            />
          </DateWrapper>
        </InputWrapper>
      </div>
    );
  };
  return (
    <ExpandCollapse topDivider={false}>
      <ExpandCollapse.Panel id="filters" header={filtersDropdownTitle}>
        <div className="row">
          {!isWlsFilter && getSelectFilters(selectFilters)}
          {getMultiSelectFilters(multiSelectFilters)}
          {getTypeAheadFilters(typeAheadFilters)}

          {getDateFilters()}
        </div>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="row"
          pt={64}
          mdJustifyContent="flex-start"
          mdWidth={100}
          mdPadding="16px 0"
          margin="0 auto"
        >
          <Button onClick={onApplyFilters} variant="secondary">
            {buttonApply}
          </Button>
          <Box width="2"> </Box>
          <Button onClick={onResetFilters}>{buttonReset}</Button>
        </Box>
      </ExpandCollapse.Panel>
    </ExpandCollapse>
  );
};

export default Filters;

Filters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  isWlsFilter: PropTypes.bool,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    filterCriteria: PropTypes.string,
    assignee: PropTypes.array,
    status: PropTypes.array,
    dealership: PropTypes.array,
    channelId: PropTypes.string,
    province: PropTypes.string,
    channelOrgCode: PropTypes.string,
    outletCode: PropTypes.string,
    createdBy: PropTypes.string
  }).isRequired,
  fieldsToHide: PropTypes.arrayOf(PropTypes.array),
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

Filters.defaultProps = {
  isWlsFilter: false,
  fieldsToHide: []
};
